import useShop from "@saleor/hooks/useShop";
import { useTheme } from "@saleor/macaw-ui";
import React, { useEffect } from "react";
import urlJoin from "url-join";

import { useStyles } from "./styles";
import { useAppActions } from "./useAppActions";

interface Props {
  src: string;
  appToken: string;
  appId: string;
  onLoad?(): void;
  onError?(): void;
}

const getOrigin = (url: string) => new URL(url).origin;

export const AppFrame: React.FC<Props> = ({
  src,
  appToken,
  appId,
  onLoad,
  onError
}) => {
  const shop = useShop();
  const frameRef = React.useRef<HTMLIFrameElement>();
  const { sendThemeToExtension } = useTheme();
  const classes = useStyles();
  const appOrigin = getOrigin(src);
  const { postToExtension } = useAppActions(frameRef, appOrigin);

  const handleLoad = () => {
    postToExtension({
      type: "handshake",
      payload: {
        token: appToken,
        version: 1
      }
    });
    sendThemeToExtension();

    if (onLoad) {
      onLoad();
    }
  };

  useEffect(() => {
    const iframe = frameRef.current;
    if (iframe) {
      iframe.addEventListener("load", handleLoad);
      iframe.addEventListener("error", onError);

      return () => {
        iframe.removeEventListener("load", handleLoad);
        iframe.removeEventListener("error", onError);
      };
    }
  }, [handleLoad, onError]);

  if (!shop?.domain.host) {
    return null;
  }

  return (
    <iframe
      title="app-iframe"
      ref={frameRef}
      src={urlJoin(src, `?domain=${shop.domain.host}&id=${appId}`)}
      className={classes.iframe}
      sandbox="allow-same-origin allow-forms allow-scripts"
    />
  );
};
